export default class TextAnimator {
    constructor() {
      this.elements = document.querySelectorAll('.gr-text-slide-up');
      this.prepareText();
      this.observer = new IntersectionObserver(this.animateText.bind(this), {
        threshold: 0.1,
        rootMargin: '0px 0px -40% 0px' // Aparece un poco antes del centro
      });
      this.observeElements();
    }
  
    prepareText() {
      this.elements.forEach(el => {
        const chars = el.textContent.trim().split('');
        el.innerHTML = chars.map((char, index) => {
          if (char === ' ') char = '&nbsp;';
          return `<span style="--char-index:${index}">${char}</span>`;
        }).join('');
      });
    }
  
    observeElements() {
      this.elements.forEach(el => this.observer.observe(el));
    }
  
    animateText(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          this.observer.unobserve(entry.target);
        }
      });
    }
  }
  